export default class FakeSelect {
  constructor(root) {
    this.root = root;
    this.select = root.querySelector('select');
    this.value = root.querySelector('.u-fake-select__value');

    this.bind();
  }

  bind() {
    this.onChange = this.onChange.bind(this);
    this.select.addEventListener('change', this.onChange);
  }

  destroy() {

  }

  onChange(e) {
    const index = this.select.selectedIndex;
    const value = this.select.options[index].textContent;

    this.value.textContent = value;
  }
}